var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDragIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1732_50348",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V16H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1732_50348)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 14C9.44772 14 9 13.5523 9 13C9 12.4477 9.44772 12 10 12C10.5523 12 11 12.4477 11 13C11 13.5523 10.5523 14 10 14ZM10 9C9.44772 9 9 8.55228 9 8C9 7.44771 9.44772 7 10 7C10.5523 7 11 7.44771 11 8C11 8.55228 10.5523 9 10 9ZM9 3C9 3.55228 9.44771 4 10 4C10.5523 4 11 3.55228 11 3C11 2.44771 10.5523 2 10 2C9.44771 2 9 2.44771 9 3Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 14C5.44772 14 5 13.5523 5 13C5 12.4477 5.44772 12 6 12C6.55229 12 7 12.4477 7 13C7 13.5523 6.55229 14 6 14ZM6 9C5.44772 9 5 8.55228 5 8C5 7.44771 5.44772 7 6 7C6.55228 7 7 7.44771 7 8C7 8.55228 6.55229 9 6 9ZM5 3C5 3.55228 5.44771 4 6 4C6.55228 4 7 3.55228 7 3C7 2.44771 6.55228 2 6 2C5.44771 2 5 2.44771 5 3Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragIcon);
export default __webpack_public_path__ + "static/media/drag-icon.53bb960d51f50da55f4387ebb0ef74cb.svg";
export { ForwardRef as ReactComponent };